import React, { useCallback } from 'react';
import {useTranslation} from 'react-i18next';

import { ReactComponent as SearchIcon } from '../assets/images/icons/search.svg';
import { useDetailViewContext } from '../context/DetailViewContext';

import styles from './styles.module.scss';
interface Props {
  click: () => void
}

export default function AdvanceModeButton({ click }: Props): JSX.Element
{
  const {t} = useTranslation('ai4Jokes');
  const { setAdvancedMode } = useDetailViewContext();
  
  const onClick = useCallback(() => {
    setAdvancedMode(true);
    click?.();
  }, [click]);

  return (
    <button 
      onClick={onClick} 
      className={styles.advanceModeButton}>
      {t('thescience.buttons.advanced')}
      <SearchIcon />
    </button>
  ) ;
}
